import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { navLinks } from '@/mocks/home';

export default function HomeNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 text-[#F5F1EB] transition-colors duration-300 ${
        scrolled || open ? 'bg-[#171515] border-b border-[rgba(245,241,235,0.12)]' : 'bg-transparent'
      }`}
    >
      <nav className="fold-shell flex h-16 md:h-20 items-center justify-between" aria-label="Main">
        <Link to="/" className="fold-serif text-[26px] md:text-[28px] leading-none tracking-[-0.03em] cursor-pointer md:w-[180px]" aria-label="FOLD. home">
          FOLD.
        </Link>
        <ul className="hidden md:flex items-center gap-12">
          {navLinks.map((l) => (
            <li key={l.href}>
              <Link to={l.href} className="fold-label whitespace-nowrap opacity-70 hover:opacity-100 transition-opacity cursor-pointer">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
        <Link
          to="/visit#pickup"
          className="hidden md:inline-flex md:w-[180px] justify-end fold-label whitespace-nowrap cursor-pointer group"
        >
          <span className="border border-[rgba(245,241,235,0.35)] px-4 py-2.5 group-hover:bg-[#F5F1EB] group-hover:text-[#171515] transition-colors">Pickup request</span>
        </Link>
        <button
          type="button"
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer whitespace-nowrap"
          aria-expanded={open}
          aria-controls="fold-mobile-menu"
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((v) => !v)}
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
        </button>
      </nav>
      {open && (
        <div id="fold-mobile-menu" className="md:hidden fold-shell pb-8 pt-2">
          <ul className="flex flex-col border-t border-[rgba(245,241,235,0.14)]">
            {navLinks.map((l) => (
              <li key={l.href} className="border-b border-[rgba(245,241,235,0.14)]">
                <Link to={l.href} onClick={() => setOpen(false)} className="fold-serif block py-5 text-3xl cursor-pointer">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
          <Link
            to="/visit#pickup"
            onClick={() => setOpen(false)}
            className="mt-6 inline-flex fold-label whitespace-nowrap border border-[rgba(245,241,235,0.4)] px-5 py-3 cursor-pointer"
          >
            Pickup request
          </Link>
        </div>
      )}
    </header>
  );
}